import { themeVars } from '@customerio/pluma-components/css/theme-tokens';
import { style } from '@vanilla-extract/css';

export const uploadIconStatus = style(
  {
    width: '24px',
    height: '24px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    flexShrink: 0,
  },
  'upload-icon-status',
);

export const popupContainer = style(
  {
    position: 'fixed',
    bottom: '20px',
    right: '110px',
    zIndex: 10_000,
    maxHeight: '83vh',
  },
  'popup-container',
);

export const popupPanel = style(
  {
    minWidth: '352px',
    maxWidth: '544px',
    backgroundColor: themeVars.color['surface-base'],
    borderRadius: themeVars.radius['6'],
    boxShadow: themeVars.depth['surface-2'],
  },
  'popup-panel',
);

export const fileList = style({ maxHeight: '352px', maxWidth: '100%' }, 'file-list');

export const fileItemBorder = style(
  {
    borderBottom: `${themeVars.border['width-0125']} solid ${themeVars.color['border-base']}`,
  },
  'file-item-border',
);

export const fileName = style({ wordBreak: 'break-all', flex: 1 }, 'file-name');

export const errorBackground = style(
  { backgroundColor: themeVars.color['surface-critical-minimal'] },
  'error-background',
);

export const progressBarContainer = style(
  {
    marginLeft: '-1px',
    marginRight: '-1px',
    marginBottom: '-1px',
    transition: 'opacity 1s',
  },
  'progress-bar-container',
);

export const progressBarHidden = style({ opacity: 0 }, 'progress-bar-hidden');

export const progressBarVisible = style({ opacity: 1 }, 'progress-bar-visible');
